import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';
import {environment} from '../../environments/environment';

@Component({
	selector: 'app-dashboard',
	templateUrl: './common-layout.component.html'
})

export class CommonLayoutComponent implements OnInit {
	emailid_1 = environment.voucher_email_1;// email id compair with username
	emailid_2 = environment.voucher_email_2;// email id compair with username

	public app : any;
	public headerThemes: any;
	public changeHeader: any;
	public sidenavThemes: any;
	public changeSidenav: any;
	public headerSelected: any;
	public sidenavSelected : any;
	public searchActived : any;
	public searchModel: any;
	public role;
	public username;
	currentUser = JSON.parse(localStorage.getItem('currentUser'));
	selected_branch = "";

	constructor( private router : Router,private cookieService: CookieService) {
		this.app = {
			layout: {
				sidePanelOpen: false,
				isMenuOpened: true,
				isMenuCollapsed: true,
				themeConfigOpen: true,
				rtlActived: false,
				searchActived: false
			}
		};  

		this.headerThemes = ['header-default', 'header-primary', 'header-info', 'header-success', 'header-danger', 'header-dark'];
		// this.changeHeader = changeHeader;
	
		function changeHeader(headerTheme) {
			this.headerSelected = headerTheme;
		}
	
		this.sidenavThemes = ['sidenav-default', 'side-nav-dark'];
		this.changeSidenav = changeSidenav;
	
		function changeSidenav(sidenavTheme) {
			this.sidenavSelected = sidenavTheme;
		}
	}


	ngOnInit(){

		var myObject = localStorage.getItem('currentUser');
		var temp = JSON.parse(myObject);
		this.role=temp["role"];
		this.username = temp ["username"];
		console.log("username = ", this.username);
		console.log(this.role);
		if (this.role === 'Admin' && (this.username === this.emailid_1 || this.username === this.emailid_2)){
			this.selected_branch = "all";
			console.log(this.selected_branch);
		}
		else{
			this.selected_branch = temp["branch"];
			console.log(this.selected_branch);
		} 
	}

	logOut(){
		if(localStorage.getItem('currentUser'))
		{
			// if(this.cookieService.check( 'uName') && this.cookieService.check( 'uPass'))
			// {
			// 	this.cookieService.delete('uName');
			// 	this.cookieService.delete('uPass');
			// }
			
			localStorage.removeItem('currentUser');
			localStorage.removeItem('user_token');
			this.router.navigate(['/login']);
		}
		
	}
}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/common/common-layout.component.ts